import React from 'react';
import { BoxWrapper } from './CommonPurchase.styles';
import {
  DetailGrid,
  DetailItem,
  DocChip,
  DocChips,
  InfoBoxGrid,
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  SectionLabel,
  StatusPill,
} from './InfoBoxV2.styles';
import ProductsTableCard from './ProductsTableCard';
import { productsTravel } from '../../../../constants';
import { downloadFile } from '../../../../../services/axios-client/axeHelpers';
import axe from '../../../../../services/axios-client/axiosClient';
import { getBrokeragePerPayment, isNewBrokerageSystem } from '../../../../helpers/brokerageHelpers';

function InfoBoxTravel({
  insuranceRequest,
  statues,
  quoteStatus,
  rc_quotation,
}) {
  const downloadResourceDocs = async (producCode) => {
    const res = await axe.get(`/travel/informativa/${producCode}`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const downloadPreventive = async () => {
    const res = await axe.get(
      `/quotations/${rc_quotation.id}/preventivo/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;

    if (rc_quotation !== null) {
      quoteInProccessAmount = parseFloat(rc_quotation.amount);
    }

    const total = quoteInProccessAmount;

    return total.toFixed(2);
  };

  return (
    <>
      <BoxWrapper>
        <InfoBoxGrid>
          <InfoCard className="pagament-status-step-one">
            <InfoCardHeader>
              <InfoCardTitle>Riepilogo</InfoCardTitle>
              <StatusPill>{statues.find((st) => st.id === quoteStatus).name}</StatusPill>
            </InfoCardHeader>
            <DetailGrid>
              <DetailItem className="full">
                <dt>Cliente</dt>
                <dd>
                  {insuranceRequest.customer.gender !== 'G'
                    ? `${insuranceRequest.customer.name} ${insuranceRequest.customer.surname}`
                    : insuranceRequest.customer.business_name}
                </dd>
              </DetailItem>
              <DetailItem className="full">
                <dt>Tipo Prodotto</dt>
                <dd>
                  {
                  productsTravel[
                    rc_quotation.quotation_data_travel_europeassistance
                      .product_code
                  ]
                }
                </dd>
              </DetailItem>
              <DetailItem>
                <dt>Destinazione</dt>
                <dd>{insuranceRequest.insurance_request_travel.country.name}</dd>
              </DetailItem>
              <DetailItem>
                <dt>Numero Persone</dt>
                <dd>
                  {insuranceRequest.insurance_request_travel
                    .insurance_request_travel_people.length + 1}
                </dd>
              </DetailItem>
              <DetailItem>
                <dt>Data Partenza</dt>
                <dd>
                  {new Date(
                    insuranceRequest.policy_effective_date,
                  ).toLocaleDateString('it-IT')}
                </dd>
              </DetailItem>
              <DetailItem>
                <dt>Il Contraente Viaggia</dt>
                <dd>
                  {insuranceRequest.insurance_request_travel
                    .is_contractor_included === 1
                    ? 'Si'
                    : 'No'}
                </dd>
              </DetailItem>
            </DetailGrid>

            <SectionLabel>Documenti</SectionLabel>
            <DocChips>
              <DocChip
                type="button"
                onClick={() => downloadResourceDocs(
                  rc_quotation.quotation_data_travel_europeassistance
                    .product_code,
                )}
              >
                Informazioni Precontrattuali
              </DocChip>
              <DocChip type="button" onClick={() => downloadPreventive()}>
                Preventivo
              </DocChip>
            </DocChips>
          </InfoCard>

          <ProductsTableCard
            className="pagament-status-step-two"
            total={getTotal()}
          >
            {rc_quotation !== null && rc_quotation.quotation_data_travel_europeassistance.product_code === 'EA0177'
              && rc_quotation.quotation_data_travel_europeassistance.quotation_data_travel_europeassistance_coverages.map(
                (coverage, index) => (
                  <React.Fragment key={index}>
                    {coverage.enabled === 0
                      && coverage.group_id === null && (
                        <tr key={index}>
                          <td>{coverage.title}</td>
                          <td>
                            {' '}
                            {rc_quotation.company_id !== null
                              ? rc_quotation.company.name
                              : rc_quotation.preventivas_company
                                .company_name}
                          </td>
                          <td>
                            {parseFloat(
                              coverage.coverage_amount_gros,
                            ).toFixed(2)}
                            {' '}
                            &euro;
                          </td>
                        </tr>
                    )}
                  </React.Fragment>
                ),
              )}
            {rc_quotation !== null && rc_quotation.quotation_data_travel_europeassistance.product_code === 'EA0190'
              && rc_quotation.quotation_data_travel_europeassistance.quotation_data_travel_europeassistance_coverages.map(
                (coverage, index) => (
                  <React.Fragment key={index}>
                    {coverage.enabled === 0
                      && coverage.group_id === '1' && (
                        <tr key={index}>
                          <td>{coverage.title}</td>
                          <td>
                            {' '}
                            {rc_quotation.company_id !== null
                              ? rc_quotation.company.name
                              : rc_quotation.preventivas_company
                                .company_name}
                          </td>
                          <td>
                            {parseFloat(
                              coverage.coverage_amount_gros,
                            ).toFixed(2)}
                            {' '}
                            &euro;
                          </td>
                        </tr>
                    )}
                  </React.Fragment>
                ),
              )}
            {rc_quotation.guarantees.map((cov, i) => (
              <tr key={i}>
                <td>{cov.guarantees_description}</td>
                <td>
                  {' '}
                  {rc_quotation.company_id !== null
                    ? rc_quotation.company.name
                    : rc_quotation.preventivas_company.company_name}
                </td>
                <td>
                  {parseFloat(cov.amount).toFixed(2)}
                  {' '}
                  &euro;
                </td>
              </tr>
            ))}
            <tr>
              <td>
                Brokeraggio
                {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) && <span className="text-success fw-bold"> (Pagato)</span>}
              </td>
              <td />
              <td>
                {parseFloat(getBrokeragePerPayment(rc_quotation)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            <tr>
              <td>Spese Di Emissione</td>
              <td />
              <td>
                {rc_quotation.payment_frequency === 1
                  ? parseFloat(rc_quotation.issuance_fee).toFixed(2)
                  : parseFloat(
                    rc_quotation.issuance_fee
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
          </ProductsTableCard>
        </InfoBoxGrid>
      </BoxWrapper>
    </>
  );
}

export default InfoBoxTravel;
